function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCallback, useEffect, useState } from 'react';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { useFollowedPropertyDialogGetFollowedPropertyQuery } from '../graphql/get-followed-property.query.generated';
import useAuthQueryParams from './use-auth-query-params';
import useModalControl from './use-modal-control';
var useFollowedPropertyControl = _ref => {
  var action = _ref.action,
    _ref$onReset = _ref.onReset,
    onReset = _ref$onReset === void 0 ? () => {} : _ref$onReset,
    _ref$onFollowedProper = _ref.onFollowedPropertyLoaded,
    onFollowedPropertyLoaded = _ref$onFollowedProper === void 0 ? () => {} : _ref$onFollowedProper,
    _ref$onSubmit = _ref.onSubmit,
    _onSubmit = _ref$onSubmit === void 0 ? () => {} : _ref$onSubmit,
    _ref$onCompleted = _ref.onCompleted,
    onCompleted = _ref$onCompleted === void 0 ? () => {} : _ref$onCompleted;
  var _useAllhomesApi = useAllhomesApi(),
    getLogger = _useAllhomesApi.getLogger;
  var log = getLogger('fe-co-allhomes-followed-properties-dialog#useFollowedPropertyControl');
  var _useAuthQueryParams = useAuthQueryParams(),
    queryParams = _useAuthQueryParams.queryParams;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    followedPropertyId = _useState2[0],
    setFollowedPropertyId = _useState2[1];
  useEffect(() => {
    log.info('action', action);
  }, [log, action]);
  var _useFollowedPropertyD = useFollowedPropertyDialogGetFollowedPropertyQuery(_objectSpread(_objectSpread({
      variables: {
        followedPropertyId: followedPropertyId
      }
    }, queryParams), {}, {
      skip: queryParams.skip || !followedPropertyId,
      onCompleted: data => data.followedProperty && onFollowedPropertyLoaded(data.followedProperty)
    })),
    queryLoading = _useFollowedPropertyD.loading,
    followedPropertyResult = _useFollowedPropertyD.data;
  var onResetCallback = useCallback(() => {
    setFollowedPropertyId(null);
    onReset();
  }, [onReset]);
  var onCompletedCallback = useCallback(() => {
    if (followedPropertyResult !== null && followedPropertyResult !== void 0 && followedPropertyResult.followedProperty && action) {
      onCompleted({
        action,
        followedProperty: followedPropertyResult === null || followedPropertyResult === void 0 ? void 0 : followedPropertyResult.followedProperty
      });
    }
  }, [action, followedPropertyResult === null || followedPropertyResult === void 0 ? void 0 : followedPropertyResult.followedProperty, onCompleted]);
  var _useModalControl = useModalControl({
      onReset: onResetCallback,
      onCompleted: onCompletedCallback
    }),
    openBaseModal = _useModalControl.openModal,
    modalProps = _useModalControl.modalProps;
  useEffect(() => {
    log.info('in useEffect', {
      followedPropertyResult,
      followedPropertyId
    });
    var followedProperty = followedPropertyResult === null || followedPropertyResult === void 0 ? void 0 : followedPropertyResult.followedProperty;
    if (followedPropertyId && followedProperty) {
      openBaseModal({
        onSubmit: () => {
          setFollowedPropertyId(null);
          if (!followedProperty.id) {
            return Promise.reject(new Error('No followed property'));
          }
          return Promise.resolve(_onSubmit(followedProperty));
        }
      });
    }
  }, [_onSubmit, followedPropertyId, followedPropertyResult, openBaseModal, log]);
  var openModal = followedId => {
    setFollowedPropertyId(followedId);
  };
  return {
    queryLoading,
    followedPropertyResult,
    openModal,
    modalProps
  };
};
export default useFollowedPropertyControl;